import type { ElementType, ReactNode } from 'react'

import type { TextRole } from './tokens'
import './system.css'

export type TextTone = 'default' | 'muted' | 'accent' | 'tone' | 'on-inverse'

export function Text({
  as: As = 'p',
  role = 'body',
  tone = 'default',
  measure = false,
  className,
  children,
}: {
  as?: ElementType
  role?: TextRole
  tone?: TextTone
  measure?: boolean
  className?: string
  children: ReactNode
}) {
  const classes = ['text', `text--${role}`, `text--${tone}`]

  if (measure) {
    classes.push('text--measure')
  }

  if (className) {
    classes.push(className)
  }

  return <As className={classes.join(' ')}>{children}</As>
}
